import example_img from "../../assets/example.png";
import example_mobile from "../../assets/example-m.png";
import "./Example.scss";

const Example = () => {
    return (
        <div className="exp">
            <div className="exp__wrapper">
                <img className="exp__mob" src={example_mobile} alt="Example" />
                <img className="exp__image" src={example_img} alt="Example" />
            </div>
        </div>
    );
}
export default Example;